import React from 'react';

import { Button } from '@splitfiesta/ui';

import { RouteChangeLink } from '@/components/common/RouteChangeLink';

interface LinkButtonProps {
  href?: string;
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary';
  size?: 'sm' | 'base';
  disabled?: boolean;
  'data-testid'?: string;
}

export function LinkButton({
  href,
  onClick,
  children,
  className = '',
  variant = 'primary',
  size = 'base',
  disabled = false,
  'data-testid': testId,
}: LinkButtonProps) {
  const baseClasses =
    'font-medium inline-flex items-center rounded-lg transition-colors';

  const variantClasses = disabled
    ? 'text-gray-400 cursor-not-allowed dark:text-gray-600'
    : variant === 'primary'
      ? 'text-orange-500 hover:text-orange-600 hover:bg-orange-50 dark:text-orange-400 dark:hover:text-orange-300 dark:hover:bg-orange-900/20'
      : 'text-gray-600 hover:text-gray-700 hover:bg-gray-50 dark:text-gray-400 dark:hover:text-gray-300 dark:hover:bg-gray-800';

  const sizeClasses =
    size === 'sm' ? 'text-sm py-1 px-2' : 'text-sm sm:text-base py-2 px-4';

  const combinedClasses =
    `${baseClasses} ${variantClasses} ${sizeClasses} ${className}`.trim();

  if (href) {
    return (
      <RouteChangeLink
        href={href}
        className={combinedClasses}
        data-testid={testId}
      >
        {children}
      </RouteChangeLink>
    );
  }

  return (
    <Button
      onClick={onClick}
      variant="ghost"
      size={size === 'sm' ? 'sm' : 'md'}
      className={combinedClasses}
      disabled={disabled}
      data-testid={testId}
    >
      {children}
    </Button>
  );
}
